// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2hz6Y","info":"UpdateTermsInfo_info__Yrqnr"};